import Env from '../config/envConfig'

import {
  AboTopicsApi as AboTopicsApiClass,
  AboSettingsApi as AboSettingsApiClass,
  Configuration as SMConfiguration,
  MediaFileApi as MediaFileApiClass,
  PageSettingsApi as PageSettingsApiClass,
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from './smModuleFetchApi'

const BASE_PATH_API = Env.restBase

export const AboTopicsApi = new AboTopicsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const AboSettingsApi = new AboSettingsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const MediaFileApi = new MediaFileApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PageSettingsApi = new PageSettingsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))
